export const updateSelectedTrim = (vehicle, selectedTrimId) => (dispatch) => {
  const newVehicle = { ...vehicle }
  newVehicle.selected_trim_id = selectedTrimId

  if (vehicle.trims) {
    const newTrim = vehicle.trims.find(
      (trim) => trim.id === Number(selectedTrimId)
    )
    newVehicle.selected_trim = newTrim

    if (newTrim && newTrim.options) {
      const typicalOptionsIds = newTrim.options.reduce((acc, option) => {
        if (option.is_typical) {
          acc.push(option.id)
        }
        return acc
      }, [])
      newVehicle.selected_option_ids = typicalOptionsIds
    }
  }

  dispatch({
    type: 'UPDATE_VEHICLE_SUCCESS',
    entity: newVehicle,
  })
}

export const updateTrimOptions = (vehicle, option) => (dispatch) => {
  const newVehicle = { ...vehicle }
  const newOptions = new Set([...vehicle.selected_option_ids])

  const { value, checked } = option
  if (checked) newOptions.add(value)
  else newOptions.delete(value)

  newVehicle.selected_option_ids = [...newOptions]

  dispatch({
    type: 'UPDATE_VEHICLE_SUCCESS',
    entity: newVehicle,
  })
}
